import {Flex} from "@styled-system/jsx";

import type {AnyFieldApi} from "@tanstack/react-form";

export const FieldInfo = ({field}: {field: AnyFieldApi}) => {
    return (
        <>
            {field.state.meta.isTouched && field.state.meta.errors && field.state.meta.errors.length > 0 ? (
                <Flex
                    justify={"start"}
                    css={{
                        fontFamily: "Barlow Condensed",
                        fontSize: "md",
                        fontWeight: "medium",
                        color: "black",
                        width: "100%",
                        margin: 0,
                        padding: 0,
                        height: "10px"
                    }}>
                    {field.state.meta.errors.join(", ")}
                </Flex>
            ) : null}
        </>
    );
};
